"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddToCartCommand = void 0;
class AddToCartCommand {
    constructor(input) {
        this.input = input;
    }
    execute(config) {
        const { value, currency, contents, content_type, content_name } = this.input;
        const { fbq: facebookQueue } = config;
        const object = {
            value: value,
            currency: currency,
            content_type: content_type ?? 'product',
            content_name: content_name,
            contents: contents?.map((content) => ({
                id: `${content.id}`,
                quantity: +content.quantity,
            })) ?? [],
            content_ids: contents?.map((content) => `${content.id}`) ?? [],
        };
        facebookQueue('track', 'AddToCart', object);
        facebookQueue('trackCustom', 'AddToCartWeb', object);
        return Promise.resolve();
    }
}
exports.AddToCartCommand = AddToCartCommand;
